/* global Messenger */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyCriterias } from './useCriterias';
import { getQueryKey as getQueryKeyCriteriaById } from './useGetCriteriaById';

// Config
import { crudConfig } from '../../../conf/predicate';

// Hooks
import { useCriteriaStoreAddPredicate } from '../../state/criteria/hooks/useCriteriaStoreAddPredicate';
import { usePredicateStoreAddPredicate } from '../../state/predicate/hooks/usePredicateStoreAddPredicate';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_PREDICATE);

export const useCreatePredicate = ({
    sessionToken,
    parentPredicateUuid,
    criteriaId,
    onSuccessCb,
    onErrorCb,
    onSettledCb
}) => {
    const Client = apiClient(crudConfig);
    const addCriteriaStorePredicate = useCriteriaStoreAddPredicate();
    const addPredicateStorePredicate = usePredicateStoreAddPredicate();

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ newPredicate }) => {
            return Client.insert(sessionToken, newPredicate);
        },
        onSuccess: (data, variables) => {
            Messenger.showMessage({
                type: `success`,
                title: `Predicate has been successfully created.`
            });
            addCriteriaStorePredicate(data, parentPredicateUuid);
            if (!variables?.context?.closeOnSuccess) {
                addPredicateStorePredicate(data);
            }
            // updateCacheArray({
            //     queryKey: getQueryKeyCriteriaResources(),
            //     action: CACHE_ACTIONS.UPDATE,
            //     primaryKey: uiConfig.primaryKey,
            //     data
            // });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyCriteriaById(criteriaId),
                refetchType: 'inactive'
            });
            onSuccessCb?.({
                data,
                context: variables?.context
            });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
